import { useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import { Script } from 'gatsby'
import { GIT_TAG_VERSION, HAND_TALK_TOKEN } from "gatsby-env-variables"

import AOS from "aos"
import favicon from "images/favicon.ico"

import CookieBar from '@garantidos/components/CookieBar'

import "./AppLayout.scss"
import { faqStructuredData } from "./data"

const AppLayout = ({ children, title, isHome = false }) => {
  const [handTalkScriptLoaded, setHandTalkScriptLoaded] = useState(false)

  useEffect(() => {
    window.__TAG__ = GIT_TAG_VERSION

    AOS.init({
      offset: 20,
      duration: 600,
      anchorPlacement: "top-bottom",
      delay: 100
    })
  }, [])

  const titleText =
    title || "Empréstimo com Garantia de Imóvel Itaú: Simule Online"
  const metaDescription =
    "O crédito com a garantia de imóvel do Itaú é a modalidade onde você pode ter uma das menores taxas do mercado. Simule seu empréstimo com imóvel de garantia e tenha a análise de crédito em até 1 hora."

  return (
    <main>
      <Helmet
        htmlAttributes={{
          lang: "pt-BR"
        }}
      >
        <meta charset="utf-8" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>{titleText}</title>
        <meta data-react-helmet="true" name="title" content={titleText} />
        <meta name="description" content={metaDescription} />

        <meta property="og:title" content={titleText} />
        <meta property="og:description" content={metaDescription} />
        <meta
          property="og:url"
          content="https://www.itau.com.br/credito-garantia-imovel/"
        />
        <meta
          property="og:image"
          content="https://www.itau.com.br/credito-garantia-imovel/images/main-page-cgi.png"
        />
        <meta property="twitter:title" content={titleText} />
        <meta property="twitter:description" content={metaDescription} />
        <link
          rel="preload"
          as="image"
          href="https://www.itau.com.br/credito-garantia-imovel/images/lp-cgi-hero-alternativo.png"
        />
        <link rel="icon" href={favicon} />
        <meta name="theme-color" content="#fafafa" />
        {isHome && (
          <script type="application/ld+json">
            {JSON.stringify(faqStructuredData)}
          </script>
        )}
      </Helmet>
      <Script
        id="handTalkPlugin"
        src="https://plugin.handtalk.me/web/latest/handtalk.min.js"
        strategy="idle"
        onLoad={() => setHandTalkScriptLoaded(true)}
      />
      {handTalkScriptLoaded && (
        <Script>{`
          var ht = new HT({
            token: "${HAND_TALK_TOKEN}",
            addonsEnabled: false,
            avatar: "MAYA"
          });
        `}</Script>
      )}
      <CookieBar />
      {children}
    </main>
  )
}
export default AppLayout
